import { Select, message } from 'antd';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { authApi } from '../../api/auth';
import { useAuthStore } from '../../store/authStore';
import { PRODUCT_NAME_DISPLAY_LANGUAGES, type ProductNameDisplayLanguage } from '../../types/api';

/**
 * Мова назв виробів у профілі (єдина номенклатура Veneto). Виріб той самий —
 * змінюється лише підпис: Антон бачить італійську, цех — українську.
 */
export function NameLanguageSelect() {
  const user = useAuthStore((s) => s.user);
  const setUser = useAuthStore((s) => s.setUser);
  const qc = useQueryClient();

  const save = useMutation({
    mutationFn: (lang: ProductNameDisplayLanguage) =>
      authApi.updateMe({ product_name_language: lang }),
    onSuccess: (fresh) => {
      setUser(fresh);
      // Назви приходять із сервера вже потрібною мовою — перечитуємо все.
      void qc.invalidateQueries();
    },
    onError: () => message.error('Не вдалося змінити мову назв'),
  });

  if (!user) return null;
  return (
    <Select
      size="small"
      variant="borderless"
      value={user.product_name_language ?? 'uk'}
      onChange={(v) => save.mutate(v)}
      loading={save.isPending}
      popupMatchSelectWidth={false}
      title="Якою мовою показувати назви виробів"
      style={{ marginLeft: -7, fontSize: 11 }}
      options={PRODUCT_NAME_DISPLAY_LANGUAGES.map((l) => ({
        value: l.value,
        label: `Назви: ${l.label.toLowerCase()}`,
      }))}
    />
  );
}
